var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphPeerRelations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDBBB",
    cx: 7.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFAB61",
    y: 15,
    width: 15,
    height: 22,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 19)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#BDD9FF",
    cx: 9,
    cy: 7.86,
    rx: 7.8,
    ry: 7.86
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5AA0FF",
    y: 18,
    width: 18,
    height: 30,
    rx: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEFB7",
    cx: 7.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD74B",
    y: 15,
    width: 15,
    height: 22,
    rx: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphPeerRelations);
export default __webpack_public_path__ + "static/media/icons_graph_peer_relations.7483bcf8e4489cb0789437bd670b8949.svg";
export { ForwardRef as ReactComponent };